/**
 * [1][2][3][4]
 */
const SHAPE_STICK = "@SHAPE_STICK";

/**
 * [1][2]
 * [3][4]
 */
const SHAPE_RECT = "@SHAPE_RECT";

/**
 *    [1]
 * [2][3][4]
 */
const SHAPE_CROSS = "@SHAPE_CROSS";

/**
 * [1][2]
 *    [3][4]
 */
const SHAPE_S_LINE = "@SHAPE_S_LINE";

/**
 * [1]
 * [2][3][4]
 */
const SHAPE_L_LINE = "@SHAPE_L_LINE"

export default {
    SHAPE_STICK,
    SHAPE_RECT,
    SHAPE_CROSS,
    SHAPE_S_LINE,
    SHAPE_L_LINE
};